/* eslint-disable */
import MainService from '@/services/MainService'
import Vue from 'vue'
import store from '@/store/index'

class Dynamics365 {
  handleError (error:any, handler:any) {
    if (process.env.VUE_APP_NODE_ENV === 'develop') {
      const errorDetail = {
        handler,
        name: error.name,
        message: error.message,
        errorResponse: error
      }
      console.error('There was an error', errorDetail)
    }
  }

  async setCotization () {
    const storage:any = store.state.storage
    const customer = storage.room.customer

    const data = {
      route: `ocular/soap/dynamics365/cotization`,
      params: customer
    }
    
    return MainService.post(data)
      .then((response) => {
        const res = response.data
      })
      .catch((error) => {
        this.handleError(error, 'Dynamics 365 - setCotization')
      })
  }
}

Vue.prototype.$dynamics365 = new Dynamics365()
